[
  {
    "id": "spirit_q_why_me",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_why_me_1",
        "text": "You want me to say that there is something in you. There may well be; I am not able to see it if there is. What I can tell you is that the choosing is not a judgement of quality — it is a judgement of position. You were close enough to the first thing that goes wrong, and unimportant enough that your absence for a day would not be investigated, and stubborn in a specific and not especially admirable way that turns out to matter enormously when a thing has to be attempted several hundred times."
      },
      {
        "id": "spirit_q_why_me_2",
        "text": "I know that is a colder answer than you wanted. I have found that people do better with the cold one. The warm one — that you were destined, that it was always going to be you — has a way of curdling around the fortieth failure into a suspicion that you were destined to fail, and I have watched what that does to somebody."
      }
    ]
  },
  {
    "id": "spirit_q_what_are_you",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_what_are_you_1",
        "text": "Honestly? Less than you are imagining, and considerably less than the paintings suggest. I am something like a witness that was left running. I have watched this world for a length of time I cannot express in your units and I have never once been able to lift so much as a cup in it."
      },
      {
        "id": "spirit_q_what_are_you_2",
        "text": "Which is the whole of the arrangement, and the whole of the frustration. I can see and I cannot act. You can act and you cannot see. Neither of us is sufficient and together we are barely adequate, and I would like you to hold on to that framing when you catch yourself waiting for me to save you at the end of something."
      }
    ]
  },
  {
    "id": "spirit_q_why_do_i_return",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_why_do_i_return_1",
        "text": "I do not know. I want that on the record before I speculate, because you are going to build plans on what I say next and you should know what they are founded on."
      },
      {
        "id": "spirit_q_why_do_i_return_2",
        "text": "My best reading is that you are not returning at all. The world is. Something out at the Ebon Citadel is doing very violent things to the shape of time in order to hold a ritual open across five hundred days without it collapsing under its own weight, and the loop is the wake of that — the world being dragged back to a fixed point over and over so the working underneath stays undisturbed. You are simply too close to the mechanism to be reset with everything else."
      },
      {
        "id": "spirit_q_why_do_i_return_3",
        "text": "If that is right, and I stress that it is a reading and not a knowledge, then the loop is not a gift and it is not a punishment. It is a side effect. And it ends when the thing causing it ends — which means every morning you wake up here is confirmation that he has not finished yet.",
        "grantsKnowledge": ["spirit_theory_loop_is_ritual_wake"]
      }
    ]
  },
  {
    "id": "spirit_q_does_anyone_else_remember",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_does_anyone_else_remember_1",
        "text": "No. With one exception, and I am permitted to tell you that much and no more, which I recognize is the most infuriating possible amount of information to be given."
      },
      {
        "id": "spirit_q_does_anyone_else_remember_2",
        "text": "You will know him when you meet him, because he will know things he cannot know. Do not assume, when that happens, that a fellow rememberer is a fellow anything else. Shared circumstance is not shared purpose. It is only shared circumstance."
      }
    ]
  },
  {
    "id": "spirit_q_who_is_the_grey_man",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_who_is_the_grey_man_1",
        "text": "The one exception. He remembers as you remember, and he has been at it a great deal longer, and the arithmetic of that is worth doing carefully rather than flinching away from: every loop you spend learning, he has already spent a hundred."
      },
      {
        "id": "spirit_q_who_is_the_grey_man_2",
        "text": "I cannot give you his name. I have tried, in the sense that something in me attempts it and stops, and I have stopped finding that interesting and started finding it sinister. But names are written down, and there are records under the temple of the First Dawn that predate the polite version of this kingdom's history. If you had the scholarship to read them, and a reason to know what you were looking for, I suspect they would tell you what I cannot."
      }
    ]
  },
  {
    "id": "spirit_q_can_he_be_killed",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_can_he_be_killed_1",
        "text": "You have already killed him. Possibly several times by now. Consider how much good it has done you and then consider that he has performed the same experiment on you rather more often, with the same result, and drew the same conclusion some ninety years before you got here."
      },
      {
        "id": "spirit_q_can_he_be_killed_2",
        "text": "You are both outside the reset. That is the entire similarity between you and it is the entire problem. Whatever ends this between the two of you, it will not be a wound — it will be a change of mind, and it will have to be his."
      }
    ]
  },
  {
    "id": "spirit_q_how_do_i_stop_him",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_how_do_i_stop_him_1",
        "text": "You take away the reason. He is not cruel and he is not mad; he is a careful man who reached a conclusion from evidence, and the conclusion is that the loop is anchored to whoever the spirit has chosen, and that it therefore ends when that person is permanently removed. He tested it on himself first. That is worth knowing about him."
      },
      {
        "id": "spirit_q_how_do_i_stop_him_2",
        "text": "He is wrong. The anchor is the ritual, not the chosen — and the proof of it is in the temple records, in the shape of an older working that produced exactly this wake centuries before either of you was born, with no chosen one anywhere near it."
      },
      {
        "id": "spirit_q_how_do_i_stop_him_3",
        "text": "So: bring him that. But understand that being right is only half of it, and the smaller half. He has been offered comfortable lies by desperate people for a century and has correctly disbelieved all of them. You will need the standing of somebody whose word is worth something in this world before he will do you the courtesy of examining your evidence at all. Earn both, then go and sit down with him.",
        "grantsKnowledge": ["knows_how_to_sever_anti_player"]
      }
    ]
  },
  {
    "id": "spirit_q_what_is_the_deadline",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_what_is_the_deadline_1",
        "text": "The working out at the citadel is not a spell in the sense your village means it. It is a construction, laid down piece by piece across five hundred and twelve days, and the reason it takes that long is that each piece has to settle before the next will bear weight."
      },
      {
        "id": "spirit_q_what_is_the_deadline_2",
        "text": "On the last day it seats. After that there is nothing to interrupt — the thing is simply true, the way winter is true, and the sun thins out over the following season and everything that needed it works out what has happened at about the same time. There is no partial version. There is before the five hundred and twelfth day, and there is after it."
      }
    ]
  },
  {
    "id": "spirit_q_why_wont_they_believe_me",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_why_wont_they_believe_me_1",
        "text": "Because you are asking them to act on a claim that cannot be checked, made by someone with no standing, about a thing that has not happened. Put it the other way around: a stranger arrives at your door and says the barn burns tomorrow, and offers nothing but their own certainty. What exactly do you imagine the correct response to that is?"
      },
      {
        "id": "spirit_q_why_wont_they_believe_me_2",
        "text": "Their scepticism is not stupidity and it is not the world being unfair to you. It is functioning judgement, applied to insufficient evidence. So stop trying to be believed and start being checkable. Find the tracks somebody else has already seen. Find the scout who came in unsettled and could not say why. Bring a man to the ridge and let him look for himself. Belief that you assemble out of things they can verify holds; belief you demand does not, and it will not survive the first person who tells them you are mad.",
        "grantsKnowledge": ["spirit_taught_evidence_matters"]
      }
    ]
  },
  {
    "id": "spirit_q_what_of_the_necromancer",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_what_of_the_necromancer_1",
        "text": "He was a scholar, a long time ago, and a rather good one. I bring that up not to humanize him but because it explains the method: he does not conquer, he opens. Tears, anchors, riftworks — every horror you have fought this loop is something he made a hole for and then walked away from, confident that the world would do the rest of the labour on his behalf. It has."
      },
      {
        "id": "spirit_q_what_of_the_necromancer_2",
        "text": "As for the sun — I have turned that over for a very long time and the only answer that fits the evidence is the least satisfying one. Everything that opposes him draws on the living world, and the living world runs on that light. He is not extinguishing it out of spite. He is doing it because it is the single cut that severs every other thing at once, and he is patient enough to spend five hundred days making it."
      }
    ]
  },
  {
    "id": "spirit_q_why_are_you_limited",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_why_are_you_limited_1",
        "text": "I have wondered that for most of my existence and I have exactly one observation to offer, which I dislike. The limit is not fixed. It moves. Every time you find something out for yourself, I discover I can discuss it — as though what I am permitted to say is priced against what you have already paid for."
      },
      {
        "id": "spirit_q_why_are_you_limited_2",
        "text": "Which suggests something is metering me, and metering me according to your effort specifically. I do not know what. I am not certain it is on your side, or on mine, or that those are the available categories. I tell you because you deserve to know that your ally is on a leash held by a hand neither of us has seen, and to weigh my advice accordingly."
      }
    ]
  },
  {
    "id": "spirit_q_does_any_of_it_count",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_does_any_of_it_count_1",
        "text": "I have been dreading this one. Not because I lack an answer — because the honest answer has two halves and you will want only the first."
      },
      {
        "id": "spirit_q_does_any_of_it_count_2",
        "text": "The first half: no. The woman you pulled out of the burning cooperage is in her bed tonight because the world was put back, not because you carried her, and she will burn again in every loop where you are elsewhere. Pretending otherwise is a comfort that will eventually break under load, and I would rather you broke it now, deliberately, than at the worst possible moment."
      },
      {
        "id": "spirit_q_does_any_of_it_count_3",
        "text": "The second half: it happened. There was a morning on which she lived because of what you did, and no reset reaches backward and makes that morning not have occurred — it only declines to keep it. And you are the sole creature in this world who carries all of those mornings. That is a terrible way to be paid and it is the only currency this place has got, and I would not blame you for finding it insufficient. I would only ask you to notice that the man who decided it was insufficient is currently trying to have you killed."
      }
    ]
  },
  {
    "id": "spirit_q_how_do_i_get_in",
    "speaker": "The Good Spirit",
    "lines": [
      {
        "id": "spirit_q_how_do_i_get_in_1",
        "text": "You do not, by the gate. I have watched more than one rememberer break themselves against that gate, certain that enough army and enough resolve would be sufficient, and it never was — it is not a lock to be forced, it is a killing-ground built to look like the only way in."
      },
      {
        "id": "spirit_q_how_do_i_get_in_2",
        "text": "There is another way, and here is the bitter shape of it: the only person who knows it is the one who has spent a century trying to stop you. He found it the way he found everything, by dying against this place more times than you have been alive. He will not sell it and he cannot be made to give it up. He will only hand it over freely, and he will only do that if you have given him the one thing he has never had — a reason to believe the loop can be ended by someone other than himself. Kill him and the door dies with him. Change his mind, and he opens it for you."
      }
    ]
  }
]
